<template>
  <div class="p-3 bg-white">
    <div id="announcementEditFormDataContainer" class="vs-con-loading__container">
        <shared-announcement-edit
          @success="onUpdateSuccess"
        ></shared-announcement-edit>

      <div class="text-center">
        <vs-button id="updateAnnouncementButton" class="m-2" color="primary" type="filled" @click.prevent="updateAnnouncement">{{ $t('save') }}</vs-button>
        <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="cancelEditAnnouncement">{{ $t('cancel') }}</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import SharedAnnouncementEdit from '@/views/Shared/Announcement/Edit'
import { EventBus } from '@/../eventbus'

export default {
  name: 'Window.Dashboard.Announcement.Edit',
  components: {
    SharedAnnouncementEdit
  },
  mounted () {
    EventBus.$emit('initAnnouncementGetFormData', this.$route.params.id)
  },
  methods: {
    updateAnnouncement () {
      EventBus.$emit('initUpdateAnnouncement')
    },
    onUpdateSuccess () {
      this.$windowOpenerHelper.notifyOpener('reload_announcements_table')
      window.close()
    },
    cancelEditAnnouncement () {
      this.$windowOpenerHelper.notifyOpener('reload_announcements_table')
      window.close()
    }
  }
}
</script>

<style scoped>

</style>
